import {Component, Input, OnDestroy, OnInit} from '@angular/core'
import {PriceRange} from '../../../../craft/price-estimation/price-range.types'
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import {faPen} from '@fortawesome/pro-regular-svg-icons/faPen'
import {Subject} from 'rxjs'
import {BreakpointService} from '../../../../craft/utils/breakpoint.service'
import {takeUntil} from 'rxjs/operators'
import {OfferingType} from '../../../../../__generated__/types'

@Component({
  selector: 'bgo-job-request-summary-card',
  templateUrl: './job-request-summary-card.component.html',
  styles: [':host{display: block;}'],
  standalone: false,
})
export class JobRequestSummaryCardComponent implements OnInit, OnDestroy {
  /** selected offering */
  @Input() offering!: {
    label: string
    fromPrice?: number
    type: OfferingType
    icon?: {name: string; collection: string}
  }
  /** Number of times this offering is selected */
  @Input() numberOfItems?: number
  @Input() priceRange?: PriceRange | undefined | null
  @Input() showBreakdown = true
  @Input() editLink?: string

  readonly completedIcon = faCheckCircle
  readonly editIcon = faPen
  readonly OfferingType = OfferingType

  private readonly unsubscribe$ = new Subject<void>()

  constructor(readonly breakpointService: BreakpointService) {}

  ngOnInit(): void {
    this.breakpointService.breakpoints$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      if (!value.sm) {
        this.showBreakdown = false
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  toggleShowBreakdown(): void {
    if (!this.priceRange?.percentageBreakdown) {
      this.showBreakdown = false
      return
    }

    this.showBreakdown = !this.showBreakdown
  }
}
